import constant from '../../constant'

const initialState = { 
  sharelp_smp_top_bar: {
    data: {
      orders: [0, 1]  //默认展示 品牌向
    },
    style: {}
  }
};

export function smp (state = initialState, action) {
  switch (action.type) {
    case constant.SMP.GET_SMP_UI_DATA:
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }

}